import React, { useEffect } from 'react';
import InsuranceTitle from '../components/InsuranceTitle';
import InsuranceParams from '../components/InsuranceParams';
import InsuranceList from '../components/InsuranceList';
import MakeBanner from '../components/banners/MakeBanner';
import AutoBanner from '../components/banners/AutoBanner';

function KascoList(props) {
  useEffect(() => {
    props.addToDataLayer();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <InsuranceTitle locale={props.locale} />
      <InsuranceParams locale={props.locale} />
      <section id="kasco_offer" className="container">
        <div className="row">
          <InsuranceList locale={props.locale} />
          <div className="right-block">
            <a href={props.locale === "ua" ? "https://polis.ua/uk/osago" : "https://polis.ua/osago"}><MakeBanner locale={props.locale} /></a>
          </div>
        </div>
      </section>
      <a href={props.locale === "ua" ? "https://polis.ua/uk/osago": "https://polis.ua/osago"}><AutoBanner locale={props.locale} /></a>
    </div>
  );
}

export default KascoList;
